import { AnyAction } from 'redux';
import type { PXQuestionsCollectionsResponse } from 'stash/types/apis/pxQuestions';
import { mapPxQuestionCollectionToState } from './utils/pxQuestionCollectionUtils';
import {
	PUT_PX_QUESTION_ANSWER_SUCCESS,
	GET_PX_QUESTION_ANSWER_SUCCESS,
	GET_PX_QUESTION_COLLECTION_SUCCESS,
} from '../../actions/api/pxQuestions';

export type PxQuestionAnswerValue = string | undefined;

type PxQuestionsState = {
	[key: string]: PxQuestionAnswerValue;
};

export const PX_QUESTION_SLUGS = {
	MARITAL_STATUS: 'marital-status',
	WORKPLACE_RETIREMENT_PLAN: 'workplace-retirement-plan',
	TAX_FILING_STATUS: 'tax-filing-status',
	ANNUAL_INCOME: 'annual-income',
	COMBINED_INCOME: 'combined-annual-income',
} as const;

export type PxQuestionSlug = typeof PX_QUESTION_SLUGS[keyof typeof PX_QUESTION_SLUGS];

type PxQuestionPutAction = {
	type: typeof PUT_PX_QUESTION_ANSWER_SUCCESS;
	questionSlug: PxQuestionSlug;
	request?: {
		body?: {
			answer?: {
				value?: PxQuestionAnswerValue;
			};
		};
	};
	response?: {
		status: number;
	};
};

type PxQuestionGetAction = {
	type: typeof GET_PX_QUESTION_ANSWER_SUCCESS;
	questionSlug: PxQuestionSlug;
	response?: {
		status: number;
		question?: {
			answer?: {
				value?: PxQuestionAnswerValue;
			};
		};
	};
};

type PxQuestionCollectionGetAction = {
	type: typeof GET_PX_QUESTION_COLLECTION_SUCCESS;
	collectionSlug: string;
	response: PXQuestionsCollectionsResponse;
};

const isSuccessfulPutResponse = (status?: number) => status === 200 || status === 204;

const initialState: PxQuestionsState = {};

const pxQuestions = (
	state: PxQuestionsState = initialState,
	action: AnyAction
): PxQuestionsState => {
	switch (action.type) {
		case PUT_PX_QUESTION_ANSWER_SUCCESS: {
			const typedAction = action as PxQuestionPutAction;
			const questionSlug = typedAction.questionSlug;
			const answerValue = typedAction.request?.body?.answer?.value;

			if (isSuccessfulPutResponse(typedAction.response?.status)) {
				return {
					...state,
					[questionSlug]: answerValue,
				};
			}
			return state;
		}
		case GET_PX_QUESTION_ANSWER_SUCCESS: {
			const typedAction = action as PxQuestionGetAction;
			const questionSlug = typedAction.questionSlug;
			const answerValue = typedAction.response?.question?.answer?.value;

			if (typedAction.response?.status === 200) {
				return {
					...state,
					[questionSlug]: answerValue,
				};
			}
			return state;
		}
		case GET_PX_QUESTION_COLLECTION_SUCCESS: {
			const typedAction = action as PxQuestionCollectionGetAction;

			return {
				...state,
				...mapPxQuestionCollectionToState(typedAction.response),
			};
		}
		default:
			return state;
	}
};

export default pxQuestions;
